export default "__VITE_ASSET__DGbkdWTd__"